import { Box, CircularProgress } from '@mui/material';
import useError from 'hooks/useError';
import moment from 'moment';
import { useEffect, useState } from 'react';
import {
    TUpdateFlyerSorting,
    TUpdatePosterSorting,
    _getCountries,
    _getPosters,
    _updatePostersOrder
} from 'routes/routes';
import DragFlyers, { Row } from '../Drag/DragFlyers';
import _config from 'config';
import { enqueueSnackbar } from 'notistack';
import DragPosters from '../Drag/DragPosters';
interface OrderProps {
    selectedCountry: string;
}
function sortArrayOfObjectsByProperty(
    arr: any,
    property: string,
    type?: string
) {
    if (type == 'asc') {
        return arr.sort((a: any, b: any) => {
            if (a[property] > b[property]) return 1;
            if (a[property] < b[property]) return -1;
            return 0;
        });
    }
    return arr.sort((a: any, b: any) => {
        if (a[property] < b[property]) return 1;
        if (a[property] > b[property]) return -1;
        return 0;
    });
}
const OrderPosters: React.FC<OrderProps> = ({ selectedCountry }) => {
    const setError = useError();
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [filteredData, setFilteredData] = useState<Row[]>([]);
    const [sortedRows, setSortedRows] = useState<
        { id: number; index: number }[]
    >([]);
    const handleRowsUpdate = (updatedRows: Row[]) => {
        const new_rows: { id: number; index: number }[] = [];
        updatedRows.forEach((item: any, index: number) => {
            // item.sort_index = index;
            const new_item = {
                id: item.id,
                index: index
            };
            new_rows.push(new_item);
        });
        setSortedRows(new_rows);
    };
    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const response = await _getPosters();
                response.data = sortArrayOfObjectsByProperty(
                    response.data,
                    'list_sort',
                    'asc'
                );
                setData(response.data);
                setLoading(false);
            } catch (err) {
                setError(err);
            }
        };
        fetchOptions();
    }, []);
    useEffect(() => {
        const filtered_data = data;
        if (selectedCountry != '-1') {
            const new_data: Row[] = filtered_data
                .filter((item) => item.country_id == selectedCountry)
                .map((item) => ({
                    ...item,
                    imageUrl: `${_config.s3_url}/${item.poster_items[0].img_path}`,
                    _name: item.name ? item.name : Math.random().toString(),
                    sort_index: item.sort_index
                }));
            setFilteredData(new_data);
        } else {
            setFilteredData([]);
        }
    }, [selectedCountry, data]);
    if (selectedCountry !== '-1' && loading) {
        return (
            <Box className="flex manage-body f24 font-bold text-[#707070] justify-center items-center">
                <CircularProgress></CircularProgress>
            </Box>
        );
    }
    const handleSubmit = async () => {
        try {
            const params: TUpdatePosterSorting = {
                posters: sortedRows
            };
            await _updatePostersOrder(params);
            //  setSubmitLoading(false);
            enqueueSnackbar('Poster Order Updated ', { variant: 'success' });
        } catch (err) {
            //  setSubmitLoading(false);
            setError(err);
        }
    };
    return (
        <Box className="h-full">
            {selectedCountry !== '-1' ? (
                <Box>
                    <Box className="w-full h-[55px] flex justify-end p-[9px] bg-[#f0f0f0] rounded-t-[10px]">
                        <button
                            onClick={handleSubmit}
                            className={`px-4 py-2 w-[161px] text-white custom-input flex justify-center items-center bg-[#72BF45]`}
                        >
                            Save
                        </button>
                    </Box>
                    <DragPosters
                        rows={filteredData}
                        onRowsUpdate={handleRowsUpdate}
                    />
                </Box>
            ) : (
                <Box className="flex manage-body f24 font-bold text-[#707070] justify-center items-center ">
                    Please select country to countinue!
                </Box>
            )}
        </Box>
    );
};

export default OrderPosters;
